import { create } from "zustand";

export const useRiskRegisterStore = create((set) => ({
    data: [],
    loading: false,
    error: null,
    pagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false,
    },
    searchQuery: "",
    sorting: {
        sortBy: 'createdAt',
        sortDirection: 'desc'
    },
    columnFilters: {},
    uniqueValues: {},

    setRiskRegisters: (data) => set({ data }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
    setPagination: (pagination) => set({ pagination }),
    setSearchQuery: (searchQuery) => set({ searchQuery }),
    setSorting: (sorting) => set((state) => ({ sorting: { ...state.sorting, ...sorting } })),
    setColumnFilters: (columnFilters) => set({ columnFilters }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues }),

    currentRisk: null,
    isFormOpen: false,
    isEditing: false,

    setCurrentRisk: (risk) => set({ currentRisk: risk }),
    openForm: (risk = null) => set({
        isFormOpen: true,
        isEditing: !!risk,
        currentRisk: risk
    }),
    closeForm: () => set({
        isFormOpen: false,
        isEditing: false,
        currentRisk: null
    }),
}));
